import UserStatusCongratulationsBenefitsCard from './UserStatusCongratulationsBenefitsCard';
import { useSelector } from 'react-redux';
import { getAppUser } from '../../../../app/appSelectors';
import BinIcon from '../../../../components/icon/IconWrapped';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import {
    UserStatusCongratulationsBenefitsCardBadgePictureStyled,
} from './styled/UserStatusCongratulationsBenefitsCardStyled';

function UserStatusCongratulationsBenefitsPersonalManager() {
    const user = useSelector(getAppUser);
    const { getLangPath } = useLangContext();

    return <UserStatusCongratulationsBenefitsCard
        badgeComponent={
            <UserStatusCongratulationsBenefitsCardBadgePictureStyled>
                {
                    user.personal_manager?.avatar_img
                        ? <img src={user.personal_manager.avatar_img}/>
                        : <BinIcon name={'IcManager'} size={32}/>
                }
            </UserStatusCongratulationsBenefitsCardBadgePictureStyled>
        }
    >
        <span
            className={'text-secondary f14 text-start'}
            dangerouslySetInnerHTML={{ __html: getLangPath('user_statuses.personal_manager.card_description') }}
        />
    </UserStatusCongratulationsBenefitsCard>;
}

export default UserStatusCongratulationsBenefitsPersonalManager;
